import { ActionReducerMap } from '@ngrx/store';

export const featureKey = 'virtualEvent';

import  {
    State as virtualEventDataState,
    reducer as virtualEventDataReducer
} from 'app/virtual-event/features/data/data.reducer';
export  {
    State as virtualEventState,
    reducer as virtualEventReducer
} from 'app/virtual-event/features/data/data.reducer';
export { DataEffects } from 'app/virtual-event/features/data/data.effects';

import {
    State as virtualEventSummaryState,
    reducer as virtualEventSummaryReducer
} from 'app/virtual-event/features/summary/summary.reducer';
export {
    State as virtualEventSummaryState,
    reducer as virtualEventSummaryReducer
} from 'app/virtual-event/features/summary/summary.reducer';
export { SummaryEffects } from 'app/virtual-event/features/summary/summary.effects';

import {
    State as virtualEventActivityState,
    reducer as virtualEventActivityReducer
} from 'app/virtual-event/features/activity/activity.reducer';
export {
    State as virtualEventActivityState,
    reducer as virtualEventActivityReducer
} from 'app/virtual-event/features/activity/activity.reducer';
export { ActivityEffects } from 'app/virtual-event/features/activity/activity.effects';

import {
    State as virtualEventLastHeroState,
    reducer as virtualEventLastHeroReducer
} from 'app/virtual-event/features/last-hero/last-hero.reducer';
export {
    State as virtualEventLastHeroState,
    reducer as virtualEventLastHeroReducer
} from 'app/virtual-event/features/activity/activity.reducer';
export { LastHeroEffects } from 'app/virtual-event/features/last-hero/last-hero.effects';

export interface State {
    data: virtualEventDataState,
    summary: virtualEventSummaryState,
    activity: virtualEventActivityState,
    lastHero: virtualEventLastHeroState
}

export const reducer: ActionReducerMap<State> = {
    data: virtualEventDataReducer,
    summary: virtualEventSummaryReducer,
    activity: virtualEventActivityReducer,
    lastHero: virtualEventLastHeroReducer
}